import {checkBrowser} from '@com.thunisoft.9law/jiulaw-browser-check';

export default {
  state: {
    // 自定义事件上报数据格式
    map: {
      // 开始时间
      st: '',
      // 结束时间
      et: '',
      // 文件包大小
      size: '',
      // 文书数据量
      cnt: '',
      status: 0
    },
    log: {
      appid: 1,
      sysid: 'tj-pc',
      vs: '1.0.15',
      lfid: '',
      fid: '',
      et: 2,
      // 用户id
      uid: '',
      // 访客id
      vid: '',
      // 页面地址
      pid: window.location.pathname,
      // 来源页面地址，父页面
      lpid: '',
      // 批次id，例：一次操作上报多条记录，batchid本次都相同，但fid都不同
      batchid: '',
    },
    checkBrowser: true,
    browserTipShow: true,
    isSafari: false
  },
  getters: {
    browserFlag: state => {
      return !state.checkBrowser && state.browserTipShow;
    },
    reportParams: state => {
      return {
        ...state.log,
        body: {
          eid: '6_1',
          map: state.map,
        }
      };
    },
  },
  mutations: {
    SET_BROWSER_TIP_SHOW:(state, show) => {
      state.browserTipShow = show;
    },
    Set_Log_Data: (state, {
      log = {}, map = {}
    }) => {
      Object.assign(state.log, log);
      Object.assign(state.map, map);
    },
    SET_BROWSER_FLAG: (state, flag) => {
      state.checkBrowser = flag;
    },
    SET_IS_SAFARI: (state, isSafari) => {
      state.isSafari = isSafari;
    },
  },
  actions: {
    SetLogData({commit}, data) {
      commit('Set_Log_Data', data);
    },
    SendReport({state}, $reportJs) {
      $reportJs.eventLog('6_1', state.map, 'post');
    },
    checkBrowser({commit}) {
      const flag = checkBrowser({safari: '605.1.15'}, false);
      const isSafari = checkBrowser({
        chrome: '999',
        safari: '0',
        edge: '999',
        firefox: '999',
        'ie': '999'
      }, false);
      commit('SET_BROWSER_FLAG', flag);
      commit('SET_IS_SAFARI', isSafari);
    }
  }
};
